jQuery(document).ready(function($) {
    var $linkAnchor = $('.link-anchor');

    if(!$linkAnchor.length) return

    $linkAnchor.on('click', function(e) {

        e.preventDefault();

        var $this = $(this);
        var link = $this.attr('href');

        $('html, body').animate({
            scrollTop: $(link).offset().top - 25
        }, 700);
    });
});